import CardBtnV2 from 'assets/Icons/cardBtnV2';
import CashBtnV2 from 'assets/Icons/cashBtnV2';
import EPayBtnV2 from 'assets/Icons/epayBtnV2';
import GiftCardBtnV2 from 'assets/Icons/giftCardBtnV2';
import LoyaltyPointBtnV2 from 'assets/Icons/loyaltyPointBtnV2';
import MultiPayBtnV2 from 'assets/Icons/multiPayBtnV2';
import Box from 'components/Box';
import Text from 'components/Text';
import ticketListSelectors from 'features/ticketList/services/selectors';
import styled from 'styled-components';
import { formatCurrency } from 'utils/formatCurrency';

const SummaryFooter = () => {
  const summaryPaymentType = ticketListSelectors.summaryPaymentType();

  return (
    <Container>
      <ItemSummary icon={<CashBtnV2 width={48} height={48} fill='#C84B31' />} value={summaryPaymentType?.cashAmount || 0} label='CASH' />
      <ItemSummary icon={<CardBtnV2 width={48} height={48} fill='#C84B31' />} value={summaryPaymentType?.creditCardAmount || 0} label='CARDS' />
      <ItemSummary icon={<GiftCardBtnV2 width={48} height={48} fill='#C84B31' />} value={summaryPaymentType?.giftCardAmount || 0} label='GIFT CARDS' />
      <ItemSummary icon={<LoyaltyPointBtnV2 width={48} height={48} fill='#C84B31' />} value={summaryPaymentType?.pointAmount || 0} label='POINTS' />
      <ItemSummary icon={<EPayBtnV2 width={48} height={48} fill='#C84B31' />} value={summaryPaymentType?.checkAmount || 0} label='CHECK' />
      <ItemSummary icon={<MultiPayBtnV2 width={48} height={48} fill='#C84B31' />} value={summaryPaymentType?.otherAmount || 0} label='OTHERS' />
    </Container>
  );
};

export default SummaryFooter;

const Container = styled.div`
  padding: 16px;
  display: flex;
  align-items: center;
  background: #f6f7fc;
  gap: 16px;
  box-shadow: 0 8px 24px 0 rgba(0, 0, 0, 0.08);
  border-radius: 12px;
`;

interface IItemSummary {
  icon: React.ReactNode;
  value: string | number;
  label: string;
}

const ItemSummary = ({ icon, value, label }: IItemSummary) => {
  return (
    <Wrapper>
      <Box display='flex' alignItems='center' gap='2'>
        <WrapperIcon>{icon}</WrapperIcon>
        <Text variant='H5' color='text_3_v2'>
          {label}
        </Text>
      </Box>
      <Text variant='H1'>{formatCurrency(value)}</Text>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 1;
  padding: 16px;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.15);
  font-family: 'Poppins';
`;

const WrapperIcon = styled.div`
  width: 64px;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff6f9;
  border-radius: 8px;
`;
